import React from 'react';
import PropTypes from 'prop-types';

import { canUserModifyPromos } from '../../../../common/helpers/users';
import Input from '../../../../common/input';
import CurrencyInput from '../../../../common/currencyInput';
import Switch from '../../../../common/checkboxSwitch';
import OptionInput from '../../../../common/optionInput';
import * as commonShapes from '../../../../common/shapes';
import AssignedShops from '../../promoCodes/components/AssignedShops';
import { RoleAllowBrand } from '../../../../auth/roleAware';
import Pill from '../../../../common/Pill';


const Form = ({
  handleSubmit,
  pristine,
  submitting,
  valid,
  rewardType,
  permissions,
  shops,
  change,
  canModify,
  isBrandPromo,
  onlyShopInBrand
}) => (
  <div className="c-wrapper">
    <div className="u-max-width-710 u-margin-auto">
      <div className="c-inner-wrapper u-pt">
        <form onSubmit={handleSubmit}>
          <fieldset disabled={!canUserModifyPromos(permissions) || submitting || !canModify}>
            <div className="u-ph">
              <div className="layout">
                <div className="layout__item" display-if={isBrandPromo && !onlyShopInBrand}>
                  <Pill type="info">brand</Pill>
                </div>
                <div className="layout__item">
                  <Switch name="enabled" label="Enabled" />
                </div>
                <div className="layout__item">
                  <span className="c-label-new">Type</span>
                  <div className="layout layout--small layout--auto">
                    <div className="layout__item">
                      <OptionInput
                        name="rewardType"
                        value="transaction"
                      >
                        Transaction based
                      </OptionInput>
                    </div>
                    <div className="layout__item">
                      <OptionInput
                        name="rewardType"
                        value="value"
                      >
                        Value based
                      </OptionInput>
                    </div>
                  </div>
                </div>
                <div
                  className="layout__item"
                  display-if={rewardType === 'transaction'}
                >
                  <span
                    className="c-label-new"
                  >
                    Number of transactions to the goal
                  </span>
                  <Input
                    className="c-input"
                    name="goalCounter"
                    type="text"
                    placeholder="Number of transactions to the goal"
                  />
                </div>
                <div
                  className="layout__item"
                  display-if={rewardType === 'value'}
                >
                  <span
                    className="c-label-new"
                  >
                    Goal value
                  </span>
                  <CurrencyInput
                    className="c-input"
                    name="goalCounter"
                    type="text"
                  />
                </div>
                <div
                  className="layout__item"
                  display-if={rewardType === 'transaction'}
                >
                  <span className="c-label-new">Qualifying value of a transactions</span>
                  <CurrencyInput
                    className="c-input"
                    name="minTransactionAmount"
                    type="text"
                    placeholder="Qualifying value of a transactions"
                  />
                </div>
                <div className="layout__item">
                  <span className="c-label-new">Reward value</span>
                  <CurrencyInput
                    type="number"
                    className="c-input"
                    name="rewardAmount"
                    placeholder="Reward value"
                  />
                </div>

                <Switch name="includeProductSales" label="Include Product Sales" wrapperClass="layout__item" />
                <Switch name="includeTips" label="Include Tips" wrapperClass="layout__item" />

                <RoleAllowBrand>
                  <div className="layout__item">
                    <span className="c-label-new">Assigned shops</span>
                    <AssignedShops shops={shops} change={change} />
                  </div>
                </RoleAllowBrand>
              </div>
            </div>
            <div className="c-separator u-mv" />
            <div className="u-text-right" display-if={canModify}>
              <button
                type="submit"
                className="c-btn u-width-120"
                disabled={pristine || !valid}
              >
                <span className="c-btn__text">Save</span>
              </button>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  </div>
);

Form.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool,
  submitting: PropTypes.bool,
  valid: PropTypes.bool,
  rewardType: PropTypes.string,
  permissions: commonShapes.permissions.isRequired,
  shops: PropTypes.array,
  change: PropTypes.func.isRequired,
  canModify: PropTypes.bool,
  isBrandPromo: PropTypes.bool,
  onlyShopInBrand: PropTypes.bool.isRequired,
};
Form.defaultProps = {
  handleSubmit: () => null,
  pristine: false,
  submitting: false,
  valid: false,
  canModify: false,
  isBrandPromo: false,
  rewardType: '',
  shops: [],
};

export default Form;
